/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react'
import NewTable from '../../components/NewTable/NewTable'
import moment from 'moment'


const MerchantSellerHistory = () => {

  const [swap, setSwap] = useState([])
  const [searchTerm, setSearchTerm] = useState('')
  const [sortBy, setSortBy] = useState('ALL')
  const [fromDate, setFromDate] = useState('')
  const [toDate, setToDate] = useState('')
  const [count, setCount] = useState([])








  

  const sortingOptions = [
    { value: 'ALL', label: 'Sort by All' },
    { value: 'pending', label: 'Sort by Pending' },
    { value: 'completed', label: 'Sort by Completed' },
    { value: 'failed', label: 'Sort by Failed' },
    { value: 'rejected', label: 'Sort by Rejected' }
  ]

  const statusStyles = {
    pending: 'bg-[#FFA600]',
    Dispatched: 'bg-[#02BC7D]'
  }

  const tableHeadings = [
    'Shop',
    'Shop URL',
    'Invoice',
    'Paid Via',
    'To Wallet',
    'Amount(Pkrd)',
    'Courier',
    'Order Status',
    'Tracking ID',
    'Review',
    'Date&Time'
  ]
  const tableRows = swap?.map((ele, index) => [
    ele?.shop,
    ele?.shopUrl,
    ele?.invoice,
    ele?.paidVia,
    ele?.toWallet,
    ele?.amountPkrd,
    ele?.courier,
    <div className='flex items-center capitalize'>
      <div
        className={`w-1 h-4 mr-2 rounded-md ${statusStyles[ele?.orderStatus] || 'bg-gray-500'
          }`}
      ></div>
      {ele?.orderStatus}
    </div>,
    ele?.trackingId,
    ele?.review,
    <span className=''>
      {moment(ele?.dateTime).format('MMMM Do YYYY, h:mm A')}
    </span>
  ])

  const summaryDataFull = {
    sent: { amount: count[0]?.totalAmount, fees: count[0]?.totalFee },
    received: { amount: count[1]?.totalAmount, fees: count[1]?.totalFee }
  }

  const handleSortByStatus = e => {
    const selectedSort = e.target.value
    setSortBy(selectedSort)
  }

  return (
    <div className='p-5 overflow-auto overflow-y-auto'>
      <NewTable
        Heading='Merchants Seller History'
        walletId='40,909'
        tableHeadings={tableHeadings}
        data={tableRows}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        showSearch={true}
        placeholder='Search by name, email, phone or ID...'
        summaryDataFull={summaryDataFull}
        showSorting={true}
        onSortByStatus={handleSortByStatus}
        sortStatusValue={sortBy}
        sortingOptions={sortingOptions}
        fromDate={fromDate}
        setFromDate={setFromDate}
        setToDate={setToDate}
        toDate={toDate}
        showDateFilter={true}
        showPageTopData2={false}
        showPageTopData3={false}
        showPageTopData4={false}
      />
    </div>
  )
}

export default MerchantSellerHistory
